/**
 * @prop --vx-select-item-height: The height of the select item. Default: 32px.
 * @prop --vx-select-outlined-color: The color of the select item border. Default: transparent.
 * @prop --vx-select-outlined-border-width: The width of the select item border. Default: 0px.
 * @prop --vx-select-outlined-border-style: The style of the select item border. Default: none.
 * @prop --vx-select-background-color: The color of the select. Default: #f7f7f7.
 */
:host {
  display: flex;
  --vx-select-border-width-on-state-change: var(--vx-select-border-width-on-state-change, 2px);
}

select {
  cursor: pointer;
  font-size: inherit;
  min-height: var(--vx-select-height, 32px);
  flex: 0 1 auto;
  font-family: inherit;
  color: inherit;
  appearance: none;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAh0lEQVQ4T93TMQrCUAzG8V9x8QziiYSuXdzFC7h4AcELOPQAdXYovZCHEATlgQV5GFTe1ozJlz/kS1IpjKqw3wQBVyy++JI0y1GTe7DCBbMAckeNIQKk/BanALBB+16LtnDELoMcsM/BESDlz2heDR3WePwKSLo5eoxz3z6NNcFD+vu3ij14Aqz/DxGbKB7CAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 90% center;
  border-color: var(--vx-select-outlined-color, transparent);
  border-width: var(--vx-select-outlined-border-width, 0);
  border-style: var(--vx-select-outlined-border-style, none);
  background-color: var(--vx-select-background-color, #f7f7f7);
  padding-left: 8px;
  border-radius: var(--mdc-shape-small, 4px);
  box-shadow: var(--vx-select-box-shadow, var(--mdc-button-raised-box-shadow), 0 3px 1px -8px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12));
  width: 100%;
}
select[disabled] {
  cursor: auto;
  box-shadow: none;
  color: var(--mdc-button-disabled-ink-color, #8c8c8c);
  background-image: none;
}
select:focus, select:active {
  border-width: var(--vx-select-border-width-on-state-change);
  outline: none;
}
select:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
}